export const mediaQueries = {
	xs:  480,
	sm:  768,
	md:  992,
	lg: 1200,
	xl: 1440,
};
